"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DateDisplay: function() {
        return DateDisplay;
    },
    toDateString: function() {
        return toDateString;
    }
});
const _localisationeq1 = require("@equiem/localisation-eq1");
const _luxon = require("luxon");
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const toDateString = (param)=>{
    let { datetime, timezone, language } = param;
    const date = _luxon.DateTime.fromMillis(datetime, {
        zone: timezone
    });
    if (language != null) {
        return _localisationeq1.formatters.datelong(date, language);
    }
    return "".concat(date.toFormat("ccc"), ", ").concat(date.toFormat("d"), " ").concat(date.toFormat("LLL"), " ").concat(date.toFormat("yyyy"));
};
const DateDisplay = (props)=>/*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, toDateString(props));

//# sourceMappingURL=DateDisplay.js.map